import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { captureGifThumbnail } from 'src/app/_helpers/utility';
import { MitField, MitFieldInfo } from 'src/app/_models/body';
import { UploadFileDto } from 'src/app/_models/uploadFileDto';
import { FileUploadService } from 'src/app/_services/file-upload.service';
import { InputFieldType } from 'src/app/common/constants';
import { Subject } from 'rxjs/internal/Subject';
import { debounceTime } from 'rxjs/internal/operators/debounceTime';
@Component({
  selector: 'app-mit-form',
  templateUrl: './mit-form.component.html',
  styleUrls: ['./mit-form.component.css']
})
export class MitFormComponent implements OnInit {
  readonly InputFieldType = InputFieldType
  readonly Infinity = Infinity
  showValidation = false
  private _enablePreUpload = true
  @Input() formGroup!: FormGroup
  @Input() dialogFields: Array<MitFieldInfo> = []
  @Input() callback!: Function
  @Input()
  set enablePreUpload(value: boolean | null | undefined) {
    this._enablePreUpload = value !== false
  }

  get enablePreUpload() {
    return this._enablePreUpload
  }
  @Output() closeEvent = new EventEmitter<void>();
  @Output() cancelEvent = new EventEmitter<void>();
  mitForm: Array<MitField> = []
  gifThumFlag = false
  private searchSubject = new Subject<{ value: string, field: MitFieldInfo }>();
  constructor(
    private fileUploadService: FileUploadService
  ) {

  }

  ngOnInit(): void {
    this.fieldMapping()
    this.searchSubject.pipe(debounceTime(500)).subscribe(({ value, field }) => {
      this.triggerSelectorSearch(value, field);
    });

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes?.dialogFields?.firstChange) {
      return
    }
    this.fieldMapping()
  }

  fieldMapping() {
    this.mitForm = this.dialogFields?.map(item => {
      return {
        ...item,
        formCtrl: this.formGroup.get(item.key)
      } as MitField
    })
  }


  private mapUrlToCtrlName(uploadedArray: Array<any>) {
    const uploaderFields = this.dialogFields.filter(item => item.type === InputFieldType.Uploader)
    if (this.gifThumFlag) {
      uploaderFields.push({ key: 'thumbnailUrl', label: '', size: 0, type: InputFieldType.Uploader })
    }
    uploaderFields.forEach(item => {
      const uploadCtrl = this.formGroup.get(item.key)
      if (!uploadCtrl) {
        return
      }
      const uploadCtrlVal = uploadCtrl.value
      if (uploadCtrlVal instanceof Array) {
        const toSetFGCtrlVal = uploadCtrlVal.map((ctrlVal: any) => {
          return uploadedArray.find((uploadedItem: any) => {
            return uploadedItem.name === ctrlVal.guid
          })
        })
        this.formGroup.patchValue({ [item.key]: toSetFGCtrlVal })
      }
    })
  }

  checkValidation() {
    this.showValidation = true
    if (this.formGroup.invalid) {
      Object.values(this.formGroup.controls).forEach(control => {
        if (control.invalid) {
          control.markAsDirty();
          control.markAsTouched();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
      return;
    }
    const toUpload = this.buildToUploadArray()
    if (toUpload.length > 0 && this.enablePreUpload) {
      this.fileUploadService.getFileDetail(toUpload, true).subscribe((uploadedArray: Array<any>) => {
        this.mapUrlToCtrlName(uploadedArray)
        this.callback.apply(this).subscribe({
          next: () => this.closeEvent.emit()
        })
      })
    } else {
      this.callback.apply(this).subscribe({
        next: () => this.closeEvent.emit()
      })
    }
  }

  private buildToUploadArray() {
    const uploaderFields = this.dialogFields.filter(item => item.type === InputFieldType.Uploader)
    let uploadArray: Array<UploadFileDto> = []
    uploaderFields.forEach(item => {
      const fgCtrlVal = this.formGroup.value[item.key]
      if (fgCtrlVal instanceof Array) {
        // 只收集真正有 File 对象的项目（新上传的文件）
        const filesToUpload = fgCtrlVal.filter((val: any) => val?.file instanceof File)
        uploadArray = uploadArray.concat(filesToUpload)
      }
    })
    const gifThumb = this.genGifThumbnail(uploadArray)
    gifThumb.length > 0 && uploadArray.push(...gifThumb)

    return uploadArray.filter((item, index, arr) => index === arr.findIndex(x => x.guid === item.guid))
  }


  genGifThumbnail(uploadArray: Array<UploadFileDto>): Array<UploadFileDto> {
    const thumb = captureGifThumbnail(uploadArray)
    if (thumb?.length > 0) {
      // only need to support AssetType === Image
      this.gifThumFlag = true
      this.formGroup.get('thumbnailUrl')?.patchValue(thumb)
    }
    return thumb
  }

  cancel() {
    this.cancelEvent.emit()
  }


  onSearch(value: string, field: MitFieldInfo): void {
    this.searchSubject.next({ value, field });
  }


  triggerSelectorSearch(ev: any, field: MitFieldInfo) {
    //!ev是为了后端分页的options假如选中后调整其他filed可能会触发一次reload，此时假如输入内容是空的话会重置options list导致原本选中的内容丢失，假如有进一步需求可以再改
    if (!field.selectorSearchEvent || !ev) {
      return
    }
    field.selectorSearchEvent.apply(this, [ev]).subscribe((res: any) => {
      field.options = res
    })
  }

  // onEnter(ev: Event, field: MitFieldInfo): void {
  //   ev.preventDefault();
  //   console.log('enter')
  //   this.triggerSelectorSearch(this.searchValue, field);
  // }


  getRequired(field: MitFieldInfo) {
    if (field.requiredEvent) {
      return field.requiredEvent.apply(this)
    }
    return field.required
  }

}
